import { Fragment, FunctionalComponent, h } from '@stencil/core';

export type SchedulerViewProps = {
  isLoading?: boolean;
  showNotification?: boolean;
  nylasBranding?: boolean;
  version?: string;
};

/**
 * The Scheduler view component.
 */
export const SchedulerView: FunctionalComponent<SchedulerViewProps> = (props: SchedulerViewProps, children) => {
  const isLoading = props.isLoading;
  const showNotification = props.showNotification;
  const nylasBranding = props.nylasBranding;
  const version = props.version;
  return (
    <Fragment>
      {showNotification && <nylas-notification></nylas-notification>}

      {isLoading && (
        <div class={'loading'}>
          <div class={'left'}>
            <div class={'skeleton'} />
          </div>
          <div class={'right'}>
            <div class={'skeleton'} />
            <div class={'skeleton'} />
            <div class={'skeleton'} />
            <div class={'skeleton'} />
            <div class={'skeleton'} />
          </div>
        </div>
      )}
      {!isLoading && children}
      <div key="ns-footer" class={'footer'} part="ns_footer">
        {nylasBranding && (
          <a
            href="https://scheduler.nylas.com?utm_source=powered-by-nylas-logoutm_medium=link&utm_campaign=get-scheduler&utm_id=get-scheduler"
            class="powered-by-nylas"
            target="_blank"
            rel="noreferrer noopener"
          >
            Powered by&nbsp;<span class="sr-only">Nylas</span>
            <nylas-logo aria-hidden={true} />
          </a>
        )}
        <tooltip-component>
          <info-icon slot="tooltip-icon" />
          <span slot="tooltip-content">{version}</span>
        </tooltip-component>
      </div>
    </Fragment>
  );
};
